module.exports = __webpack_public_path__ + "static/img/CO.57a2c71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/states/CO.jpg
// module id = 4+/h
// module chunks = 0